module.exports = __webpack_public_path__ + "media/images/header-club-3715cfa4dedcc215a50b5e4511b1c73f.jpeg";